import Checkbox from '@mui/material/Checkbox';
import { FC } from 'react';
import { useYodaField } from 'services/yodaForm';
import { YodaFieldValidation } from 'services/yodaForm/yodaForm.types';
import FormControlLabel from 'yoda-ui/Form/FormControlLabel';

export type CheckBoxYodaProps = {
  label: string;
  name: string;
  disabled?: boolean;
  onChange?: Function;
  checked?: boolean;
  validation?: YodaFieldValidation;
};

const CheckBoxYoda: FC<CheckBoxYodaProps> = ({
  label,
  name,
  disabled = false,
  onChange,
  checked,
  validation,
}) => {
  const { onSwitchField,
    fieldValue } = useYodaField({ name, defaultValue: checked, onChange, validation });

  return (
    <FormControlLabel
      control={
        (
          <Checkbox
            checked={ !!fieldValue }
            color="primary"
            onChange={ onSwitchField }
            disabled={ disabled }
          />
        )
      }
      label={ label }
    />
  );
};

export default CheckBoxYoda;
